import classNames from "classnames/bind";
import styles from "./ModalAddObject.module.css";
import { useCallback, useEffect, useRef, useState } from "react";
import { colum } from "./configModalAddObject";
import Filter from "./Filter";
import { Button, Empty, HeaderModal, ImageObject, Loading, Pagination, Table, Toast } from "../../../../../../components";
import { Close } from "../../../../../../components/Icons/Icons";
import { objectLockFRS } from "../../../../../../services/api/objectLockFRS";
import { listObjectFSR } from "../../../../../../services/api/listObjectFSR";
import { getTimeFormArray } from "../../../../../../utils";
import { useTranslation } from "react-i18next";
const cx = classNames.bind(styles)

const ModalAddObject = ({ organizationCode, onClose, onReFresh, camsDefault = [], cameraCode }) => {
    const refModal = useRef(null)
    const [filter, setFilter] = useState({
        name: null,
        department: null,
        page: 1,
        totalPage: 1,
        size: 10,
        organizationCode: organizationCode?.company_code || null,
        organizationName: organizationCode?.company_name || null,
    })
    const [listObjectAdd, setListObjectAdd] = useState(camsDefault)
    const [listObject, setListObject] = useState([])
    const [listObjectChecked, setListObjectChecked] = useState([])
    const [loading, setLoading] = useState(false)
    const [reFresh, setRefresh] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const { t } = useTranslation()

    useEffect(() => {
        const handleCloseOnClickOutSide = (e) => {
            if (e.target === refModal.current) {
                onClose();
            }
        };
        document.addEventListener("click", handleCloseOnClickOutSide);
        return () => {
            document.removeEventListener("click", handleCloseOnClickOutSide);
        };
        // eslint-disable-next-line
    }, []);
    const handleChosePage = (page) => {
        setFilter(prev => ({ ...prev, page: page }))
        setListObject([])
        setLoading(true)
    }
    const handleNextPage = () => {
        setFilter(prev => ({ ...prev, page: prev.page + 1 }))
        setListObject([])
        setLoading(true)
    }
    const handlePrevPage = () => {
        setFilter(prev => ({ ...prev, page: prev.page - 1 }))
        setListObject([])
        setLoading(true)
    }
    const handleChangeFilter = (key, val) => {
        setFilter(prev => ({ ...prev, [key]: val, page: 1 }))
        setListObject([])
        setLoading(true)
    }

    const handleChangeChecked = (check, id) => {
        if (check) {
            setListObjectAdd(prev => [id, ...prev])
        } else {
            const otherCam = listObjectAdd?.filter(item => item !== id);
            setListObjectAdd(otherCam)
        }
    }

    const handleAccept = async () => {
        setModalLoading(true)
        try {
            const infoAdd = {
                cameraCode: cameraCode,
                serviceCode: "20230222000000000002",
                companyCode: organizationCode?.company_code || "",
                objectIds: listObjectAdd
            }
            await objectLockFRS.postAdd(infoAdd);
            setModalLoading(false)
            setRefresh(!reFresh)
            onReFresh()
            Toast.open(t('faceDetect.Object_added_to_lock_list_successfully'), "success")
            setListObjectAdd([])
        } catch (error) {
            if (error?.response?.data?.objectIds) {
                Toast.open(`${error?.response?.data?.objectIds}`, "danger")
            } else {
                Toast.open(t('faceDetect.Adding_object_to_lock_list_failed'), "danger")
            }
            setModalLoading(false)
        }
    }

    const getCameraNotInLockFile = async () => {
        try {
            const param = {
                id_department: filter?.department,
                nameStaff: filter?.name,
                page: filter?.page,
                limit: filter?.size,
                organization_code: filter?.organizationCode === 'all' ? null : filter?.organizationCode,
                camera_code: cameraCode
            }
            const res = await listObjectFSR.get(param);
            if (res && res?.data) {
                const objects = res?.data?.map((item, index) => {
                    return {
                        id: item?.id,
                        // stt: index + 1,
                        name: item?.staffName || '',
                        department: item?.nameDepartment || "",
                        time: item?.timeAdd ? getTimeFormArray(item?.timeAdd) : '',
                        organization_name: item?.organizationName || "",
                        // avatar: <div className={cx('image-avatar')}><img style={{ height: '100%' }} src={item?.image ? `${process.env.REACT_APP_FSR_IP}${item?.image}` : image} /></div>,
                        avatar: <ImageObject src={item?.image} />,
                    };
                })
                setListObject(objects)
            }
            setFilter(pre => ({ ...pre, totalPage: Math.ceil(res?.totalElement / filter?.size) }))
            setLoading(false)
        } catch (error) {
            setLoading(false)
            Toast.open(t('faceDetect.Get_list_failed'), 'danger')
        }
    }

    useEffect(() => {
        getCameraNotInLockFile()
    }, [filter.name, filter.page, cameraCode, filter?.department, filter?.organizationCode, reFresh])

    useEffect(() => {
        const cameras = listObject?.map(item => {
            const check = !!listObjectAdd.find(it => it === item?.id)
            return {
                stt: <input
                    type="checkbox"
                    checked={check}
                // onChange={(e) => handleChangeChecked(e.target.checked, item?.id, item?.detail)}
                />,
                ...item
            }
        })
        setListObjectChecked(cameras)
    }, [listObject, listObjectAdd])

    const handleClickRow = (val) => {
        const check = !!listObjectAdd.find(item => item === val?.id);
        handleChangeChecked(!check, val?.id)
    }
    return (
        <div className={cx('wrraper-modal')} ref={refModal}>
            <div className={cx('content')}>
                <HeaderModal onClose={onClose} title={t('faceDetect.object')} />
                <Filter onChangeFilter={handleChangeFilter} value={filter} />
                <div className={cx('table')}>
                    <Table colum={colum} data={listObjectChecked} onClick={handleClickRow} />
                    {listObjectChecked?.length == 0 && !loading && <Empty title={t('smartReport.noDataMatch')} />}
                    {loading && <div className={cx('loading')}>
                        <Loading />
                    </div>}
                </div>
                {listObjectChecked?.length > 0 && !loading && <div className={cx('pagination')}>
                    <Pagination
                        onClick={handleChosePage}
                        onNext={handleNextPage}
                        onPrevious={handlePrevPage}
                        pages={filter.totalPage}
                        currentPage={filter.page}
                    />
                </div>}
                <div className={cx('foolter')}>
                    {/* <Button title={'Hủy bỏ'} className={cx('cancel')} onClick={onClose} /> */}
                    <Button title={t('stream.acceptCustom')} className={cx('accept')} onClick={handleAccept} />
                </div>
                {modalLoading && <div className={cx("modal-loading")}><Loading /></div>}
            </div>
        </div>
    )
}

export default ModalAddObject;